import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';


@Component({
  selector: 'app-out-of-service',
  templateUrl: './out-of-service.component.html',
  styleUrl: './out-of-service.component.scss'
})
export class OutOfServiceComponent implements OnInit {

  constructor(private apiService: ApiService,private alertService: AlertService) { }
  workingHours: string = ''

  ngOnInit(): void {
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.workingHours = response.settings.working_hours
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }
}
